import React from "react";
import { Box, Typography } from "@mui/material";
import ScreenSearchDesktopIcon from "@mui/icons-material/ScreenSearchDesktop";

const NotFoundPage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "calc(100vh - 50px)",
        backgroundColor: "#F7F8FB", // Matches specific background used in other pages
      }}
    >
      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          borderRadius: "12px",
          padding: "48px 24px",
          textAlign: "center",
          maxWidth: "480px",
          width: "100%",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "24px",
          }}
        >
          <ScreenSearchDesktopIcon
            sx={{
              fontSize: "64px",
              color: "#403C6F", // Primary theme color
              stroke: "#FFFFFF",
              strokeWidth: 0.5,
            }}
          />
        </Box>

        <Typography
          variant="h5"
          component="h1"
          sx={{
            fontWeight: 700,
            color: "#080A0E",
            marginBottom: "16px",
            fontSize: "18px",
          }}
        >
          404 - Page Not Found
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "#6F727A",
            fontSize: "14px",
            lineHeight: "1.5",
          }}
        >
          The page you requested could not be found. It may have been moved,
          renamed, or is temporarily unavailable.
        </Typography>
      </Box>
    </Box>
  );
};

export default NotFoundPage;
